'use client';

import { websiteEnv } from '@/constants/website-env';
import mergeOperations from '@/util/shallowMerge';
import { useLazyQuery } from '@apollo/client';
import Image from 'next/image';
import { useCallback, useEffect, useMemo, useState } from 'react';
import GET_COLORCHART from './colorChart.gql';
import classes from './colorChart.module.css';

export const ColorChart = props => {
  const operations = mergeOperations(GET_COLORCHART, props.operations);
  const { GetColorChart } = operations;
  const [fetchColorChart, { data, error, loading }] = useLazyQuery(GetColorChart, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });
  const contentdata = useMemo(() => {
    return data?.getColorChart || [];
  }, [data]);
  const [previewImage, setPreviewImage] = useState([...contentdata.map(item => item.pic)]);

  const [coloritem_select, setColoritem_select] = useState();

  useEffect(() => {
    fetchColorChart();
    setPreviewImage([...contentdata.map(item => item.pic)]);
    setColoritem_select([...contentdata.map(() => 0)]);
  }, [contentdata, data, fetchColorChart]);

  const changeImageView = useCallback(
    (itemsindex, pic, colorindex) => {
      previewImage[itemsindex] = pic;
      setPreviewImage([...previewImage]);
      const tempdata = coloritem_select;

      coloritem_select.map((item, cdindex) => {
        if (itemsindex == cdindex) {
          tempdata[itemsindex] = colorindex;
        }
      });
      setColoritem_select([...tempdata]);
    },
    [previewImage, coloritem_select],
  );

  return (
    <>
      <div className={classes.colorchart}>
        <h1 className={classes.title}>{websiteEnv.isUnitedKingdom ? 'COLOUR CHART' : 'COLOR CHART'}</h1>
        <div className={classes.conent}>
          {contentdata.map((item, conindex) => (
            <div
              className={classes.item}
              key={conindex}
            >
              <div className={classes.baseinfo}>
                <Image
                  className={classes.entityimg}
                  src={previewImage.length ? previewImage[conindex] : item.pic}
                  alt='Color Chart'
                  width={320}
                  height={320}
                />
                <div className={classes.detailinfo}>
                  <p className={classes.name}>{item.title}</p>
                  <p className={classes.features}>{item.description}</p>
                  <a
                    className={classes.shop}
                    href={item.link_1}
                  >
                    {item.link_text_1}&nbsp;&nbsp;+
                  </a>
                  <br />
                  {item.link_2 && (
                    <a
                      className={classes.shop}
                      href={item.link_2}
                    >
                      {item.link_text_2}&nbsp;&nbsp;+
                    </a>
                  )}
                </div>
              </div>
              <div className={classes.colorlist}>
                <ul className={classes.coloritems}>
                  {item.colors.map((item, index) => {
                    let background = {};

                    if (item.rgb) {
                      background = {
                        background: item.rgb,
                      };
                    } else {
                      background = {
                        backgroundImage: `url(${item.pic})`,
                        backgroundSize: 'contain',
                      };
                    }

                    return (
                      <li
                        className={[
                          classes.coloritem,
                          coloritem_select[conindex] == index ? classes.active : null,
                        ].join(' ')}
                        key={index}
                        onClick={() => changeImageView(conindex, item.pic, index)}
                      >
                        <div
                          className={[classes.colorpic, item.title == 'White' ? classes.colorpicwhite : null].join(' ')}
                          data-colorindex={index}
                          style={background}
                          data-name={item.title}
                        />
                        <span className={classes.colorname}>{item.title}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ColorChart;
